import * as GetTestTypes from 'src/actions/aptitude-test/get/Types';
import AptitudeTest from 'src/entities/AptitudeTest';
import { GetAptitudeTestAction, GetAptitudeTestSuccess } from 'src/actions/aptitude-test/get/GetAptitudeTest.actions';

export interface GetAptitudeTestState {
  aptitudeTest?: AptitudeTest;
  loading: boolean;
  error: boolean;
  errorMessage: {};
}

const initialState: GetAptitudeTestState = {
  loading: false,
  error: false,
  errorMessage: {}
};

export function GetAptitudeTestReducer(
  state: GetAptitudeTestState = initialState,
  action: GetAptitudeTestAction
): GetAptitudeTestState {

  switch (action.type) {
    case GetTestTypes.GET_APTITUDE_TEST_ATTEMPT:
      return {...state, aptitudeTest: undefined, loading: true, error: false};
    case GetTestTypes.GET_APTITUDE_TEST_SUCCESS:
      const aptitudeTest: AptitudeTest = (action as GetAptitudeTestSuccess).payload;
      return {...state, aptitudeTest: aptitudeTest, loading: false, error: false};
    case GetTestTypes.GET_APTITUDE_TEST_FAILURE:
      return {
        ...state,
        aptitudeTest: undefined,
        loading: false,
        error: true,
        errorMessage: action.payload
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/aptitude-test/GetAptitudeTestReducer.tsx